<template>
  <div class="content">
    <div class="interface">

      <avatar :recipe="currentRecipe" />

      <template v-for="item, key in availableParts">
        <div v-for="direction in ['prev', 'next']" :class="['bt', key, direction]" :data-part="key" :data-direction="direction" :key="`bt-${key}-${direction}`"></div>
      </template>

    </div>
    <a class="btnPush button" @click="save">Enregistrer</a>
  </div>

</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Avatar from '@/components/Avatar'
  import Bouton from '@/components/Bouton'
  import BadgeDB from '@/datas/badges.json'

  export default {
    props: ['recipe', 'editable'],
    components: { Avatar, Bouton },
    data () {
      let notifications = this.$store.state.notifications

      let availableParts = {
        body: ["blue", "fluffy", "green", "pink", "red", "yellow"],
        eyeAccessory: ["none", "clown", "eyebrow", "minion", "monocle", "pirate", "star"],
        eye: ["fear", "fun", "furious", "suspicious", "think", "want"],
        hat: ["none", "classy", "devilHorns", "feathers", "music", "snowCap", "unicornHorn"],
        mouth: ["bigSmile", "full", "poker", "reverse", "smile", "surprise"],
        neck: ["none", "beard", "blueScarf", "blueTie", "redScarf", "redTie", "skyTie"],
        nose: ["none", "bigMustache", "dandyMustache", "clown", "upMustache", "mask", "pig"]
      }

      let ownedBadges = this.$store.getters.badges
      for (let ownedParts of ownedBadges.map(b => BadgeDB[b].avatarParts)) {
        for (let partType in ownedParts) {
          availableParts[partType] = availableParts[partType].concat(ownedParts[partType])
        }
      }

      return {
        currentRecipe: this.recipe,
        availableParts
      }
    },
    mounted () {
      var selectedPartsIndexes = {}
      let currentCorrectedRecipe = ""
      for(let partType in this.availableParts) {
        let partList = this.availableParts[partType]
        for(let partIndex in partList) {
          let partName = partList[partIndex]
          if (this.currentRecipe.indexOf(`${partType}-${partName}`) !== -1) {
            selectedPartsIndexes[partType] = parseInt(partIndex)
            break
          }
          selectedPartsIndexes[partType] = 0
        }
        currentCorrectedRecipe += `${partType}-${this.availableParts[partType][selectedPartsIndexes[partType]]} `
      }
      this.currentRecipe = currentCorrectedRecipe

      document.querySelectorAll('.bt').forEach((item) => {
         item.addEventListener("click", (evt) => {
           var bt = evt.currentTarget;
           var direction = bt.dataset.direction == 'prev' ? -1 : +1
           var partType = bt.dataset.part

           let newPartId = (selectedPartsIndexes[partType] += direction + this.availableParts[partType].length) % this.availableParts[partType].length

           selectedPartsIndexes[partType] = newPartId
           this.currentRecipe = this.currentRecipe.replace(RegExp(`${partType}-(\\w)+`), `${partType}-${this.availableParts[partType][newPartId]}`)
           console.log(this.currentRecipe, `${partType}-${this.availableParts[partType][newPartId]}`)
         });
      })
    },
    methods: {
      ...mapActions([ 'updateMe']),
      async save (e) {
        e.preventDefault();
        try {
          let userCommit = {
            avatar: this.currentRecipe
          }
          await this.updateMe({ userCommit });
          this.$router.push({name: 'dashboard'})
        } catch (ex) {
          console.log('error', ex);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
$parts: 
  hat 3 6,
  eyeAccessory 1 6,
  eye 2 6,
  nose 5 6,
  mouth 4 6,
  neck 6 6,
  body 0 6;

.interface {
  margin: 0px auto 50px;
  position: relative;
  width: 300px;
  height: 275px;
}

.content {
  margin: 0px auto;
  transition: all .3s ease;
  max-width: 400px;
  width: 100%;
  border-radius: 15px;
  padding: 25px 35px;
  text-align: center;
  position: relative;
}

.bt {
  $height: 30px;
  $bt-margin: 10px;
  position: absolute;
  color: white;
  background: #C9BCB9;
  border-radius: 50%;
  width: $height;
  height: $height;
  text-align: center;
  line-height: $height;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease 0s;
    &:hover {
  background: #182EB3;
  }
  &.prev {
    left: 0;
    &::after {
      content: "<";
    }
  }
  &.next {
    &::after {
      content: ">";
    }
    right: 0;
  }
  
  &.prev.hat {
    left: 50px;
  }
  &.next.hat {
    right: 50px;
  }
  &.prev.eyeAccessory {
    left: 30px;
  }
  &.next.eyeAccessory {
    right: 30px;
  }
  &.prev.eye {
    left: 10px;
  }
  &.next.eye {
    right: 10px;
  }
  &.prev.nose {
    left: 0px;
  }
  &.next.nose {
    right: 0px;
  }
  &.prev.mouth {
    left: 10px;
  }
  &.next.mouth {
    right:10px;
  }
  &.prev.neck {
    left: 30px;
  }
  &.next.neck {
    right:30px;
  }
  &.prev.body {
    left: 50px;
  }
  &.next.body {
    right: 50px;
  }
  &.prev.voice {
    left: 100px;
    top: 200px;
  }
  &.next.voice {
    right: 100px;
    top: 200px;
  }
  @for $i from 1 through length($parts) {
    $partsType: nth($parts, $i);
    $partsTypeName: nth($partsType, 1);
    &.#{$partsTypeName} {
      top: ($i - 1) * ($height + $bt-margin);
    }
  }
}

.parts {
    display: inline;
    position: absolute;
    width: auto;
    height: 50px;
    background-color: #C9BCB9;
    left: 50px;
    right: 50px;
    bottom: 20px;
    div {
      background: url('~@/assets/images/mascotte/all_pieces_icon.png');
      width: 50px;
      height: 50px;
      float: left;
    }
  
    @each $part, $index, $numItems in $parts {
      $positionY: -$index * 51px;
      &[data-selected|="#{$part}"] div {
        background-position-y: $positionY;
      }
      @for $i from 1 through 10 {
        &[data-selected$="-#{$i}"] div:nth-child(1) {
          background-position-x: (-($i - 2) + 1) * 50px;
        }
        &[data-selected$="-#{$i}"] div:nth-child(2) {
          background-position-x: (-($i - 1) + 1) * 50px;
        }
        &[data-selected$="-#{$i}"] div:nth-child(3) {
          background-position-x: (-$i + 1) * 50px;
        }
        &[data-selected$="-#{$i}"] div:nth-child(4) {
          background-position-x: (-($i + 1) + 1) * 50px;
        }
        &[data-selected$="-#{$i}"] div:nth-child(5) {
          background-position-x: (-($i + 2) + 1) * 50px;
        }
        
      }
    }
}

.bt:not(:hover) .bubble-container { display: none; }

.bubble {
  position: absolute;
  width: 80px;
  height: 80px;
  border: solid 2px #21084F;
  border-radius: 50px 50px 50px 0px;
}

.prev .bubble {
  bottom: 5px;
  left: -100px;
  transform: rotate(250deg);
}

.next .bubble {
  bottom: 5px;
  left: 45px;
  transform: rotate(20deg);
}

.bt .part-item {
  background: url('~@/assets/images/mascotte/all_pieces_icon.png') no-repeat;
  width: 50px;
  height: 50px;
  position: absolute;
  top: -40px;
  z-index: 100;
} 
.bt.next .part-item {
  left: 60px;
} 
.bt.prev .part-item {
  left: -80px;
} 
@each $part, $index, $numItems in $parts {
  $positionY: -$index * 51px;
  .bt.#{$part} .part-item {
    background-position-y: $positionY;
  }
}
.bt[data-part="0"] .part-item {
  background-position-x: 51px;
}
@for $i from 1 through 8 {
  $positionX: -($i - 1) * 51px;
  .bt[data-part="#{$i}"] .part-item {
    background-position-x: $positionX;
  }
}

@media (max-width: 550px) {
  .interface { top: -50px; left: -60px; height: 210px;}
  .bubble-container {display: none;}
}

</style>
